import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { normalizeParticipantIds } from "@/features/chat/utils/participants";
import { chatsApi } from "@/lib/humhub-api/chats";
import type { ChatRoomType, ExistingChatSummary } from "@/lib/humhub-api/types";

export const useExistingChatByParticipants = (
  participantIds: number[],
  type?: ChatRoomType,
  enabled = true,
) => {
  const normalizedIds = useMemo(
    () => normalizeParticipantIds(participantIds),
    [participantIds],
  );

  const query = useQuery({
    queryKey: ["chatExistingByParticipants", { type, ids: normalizedIds }],
    queryFn: () => chatsApi.findChatRoomByParticipants(normalizedIds, type),
    enabled: enabled && normalizedIds.length > 0,
    staleTime: 15 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    select: (data) => data ?? [],
  });

  return {
    existingChats: (query.data ?? []) as ExistingChatSummary[],
    isCheckingExisting: query.isLoading || query.isFetching,
    error: query.error ? String(query.error) : null,
  };
};
